import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';

import { FormColumn, FormRow } from 'components/Form';
import Alert from 'components/Alert';
import Spinner from 'components/Spinner';
import { checkinAction } from 'actions/workflow';

const GeneralError = ({ error, className }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isRefreshing, setIsRefreshing] = useState(false);

  if (!error) return null;

  const { message, subject } = error;

  if (!message) return null;

  const handleRefresh = (e) => {
    e.preventDefault();
    setIsRefreshing(true);

    dispatch(checkinAction({
      skipActivityCheck: true,
      key: searchParams.get('key'),
      success: (res) => {
        setIsRefreshing(false);
        navigate(get(res, 'data.url') || '/');
      },
      fail: () => {
        setIsRefreshing(false);
      },
    }));
  };

  return (
    <FormRow className={className}>
      <FormColumn>
        <Alert variant="danger">
          <p className="text-sm">
            {message}
          </p>
          {subject === 'InvalidActivity' && (
            isRefreshing ? (
              <Spinner size={4} color="blue-400" className="mt-1 !justify-start" />
            ) : (
              <a
                href="#"
                className="text-sm block mt-0.5 text-blue-600 hover:text-blue-700 underline"
                onClick={handleRefresh}
              >
                Click here to refresh
              </a>
            )
          )}
        </Alert>
      </FormColumn>
    </FormRow>
  );
};

GeneralError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    subject: PropTypes.string,
  }),
  className: PropTypes.string,
};

GeneralError.defaultProps = {
  error: null,
  className: undefined,
};

export default GeneralError;
